var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1873 6.13379C11.5862 5.57728 12.4138 5.57728 12.8127 6.13379L13.4755 7.05832C13.6973 7.36768 14.0754 7.52432 14.451 7.46238L15.5733 7.27726C16.2489 7.16584 16.8342 7.75106 16.7227 8.42667L16.5376 9.54903C16.4757 9.92459 16.6323 10.3027 16.9417 10.5245L17.8662 11.1873C18.4227 11.5862 18.4227 12.4138 17.8662 12.8127L16.9417 13.4755C16.6323 13.6973 16.4757 14.0754 16.5376 14.451L16.7227 15.5733C16.8342 16.2489 16.2489 16.8342 15.5733 16.7227L14.451 16.5376C14.0754 16.4757 13.6973 16.6323 13.4755 16.9417L12.8127 17.8662C12.4138 18.4227 11.5862 18.4227 11.1873 17.8662L10.5245 16.9417C10.3027 16.6323 9.92459 16.4757 9.54903 16.5376L8.42667 16.7227C7.75106 16.8342 7.16584 16.2489 7.27726 15.5733L7.46238 14.451C7.52432 14.0754 7.36768 13.6973 7.05832 13.4755L6.13379 12.8127C5.57728 12.4138 5.57728 11.5862 6.13379 11.1873L7.05832 10.5245C7.36768 10.3027 7.52432 9.92459 7.46238 9.54903L7.27726 8.42667C7.16584 7.75106 7.75106 7.16584 8.42667 7.27726L9.54903 7.46238C9.92459 7.52432 10.3027 7.36768 10.5245 7.05832L11.1873 6.13379Z",
    stroke: "#F1F5F8",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.75,
    stroke: "#F1F5F8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.ccb6223ed60ed8d81bd266428f1fb0b5.svg";
export { ForwardRef as ReactComponent };